// John Eldhose 20201006
import React, { Component } from 'react';
import { Button, Checkbox, Grid, Typography } from '@material-ui/core';
import { Clear, Done } from '@material-ui/icons';
import { resetLoginPage } from '../lib/LoginPage';
import ReconfigSearch from '../lib/ReconfigSearch';
import Loading from '../lib/Loading';
import { postData } from '../lib/api';
import ProfileAddress from '../lib/ProfileAddress';
import Subscription from '../lib/Subscription';
import Checkout from '../lib/Checkout';

class Reconfig extends Component {

  state = {
    step: 'begin',
    sn: ((window.location.search === '') ? '' : decodeURI(window.location.search.substring(1)).toUpperCase()),
    parts: [],
    profile: null,
    address: null,
    baddress: null
  }
  componentWillMount() {
    resetLoginPage();
  }
  handleChange = (sn) => {
    this.setState({ step: 'begin', sn: sn, parts: [] });
  }
  sns = {};
  parts = (data) => {
    var parts = [];
    if(typeof data.package[0] === 'object') {
      parts.push([
        data.package[0].NAME, parseInt(data.package[0].masterprice, 10), 'm'
      ]);
// available, exist, master part, required, upgrade
      data.package.map((row) => parts.push([
        row.MODNAME, parseInt(row.PRICE, 10),
        ((typeof data.modules[row.MODNUM] === 'object') ? 'e' : ((row.REQUIRED === 'T') ? 'r' : 'a'))
      ]));
    }
    parts.push([
      data.plan, ((data.current === 'true') ? 0 : data.price), 'u'
    ]);
    this.setState({ parts: parts });
  }
  handleSearch = () => {
    const sn = this.state.sn;
    if(sn.length < 15 || !/[A-Z0-9]+-[A-Z0-9]+-[A-Z0-9]+-[A-Z0-9]+/.test(sn))
      this.setState({ step: 'invalid' });
    else if(typeof this.sns[sn] === 'undefined') {
      this.setState({ step: 'loading' });
      postData('reconfigProduct', {sn: sn})
        .then((res) => {
          if(res.status === 'false') {
            this.sns[sn] = null;
            this.setState({ step: 'ineligible' });
          }
          else if(res.status === 'true') {
            this.sns[sn] = res.data[sn];
            this.parts(this.sns[sn]);
            this.setState({ step: 'found' });
          }
          else
            this.setState({ step: 'error' });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ step: 'error' });
        })
    }
    else if(this.sns[sn] === null)
      this.setState({ step: 'ineligible' });
    else {
      this.parts(this.sns[sn]);
      this.setState({ step: 'found' });
    }
  }
  subtotal = () => {
    var st = 0;
    for(var i = 0; i < this.state.parts.length; i++)
      if(['a', 'e'].includes(this.state.parts[i][2]) === false)
        st += this.state.parts[i][1];
    return st;
  }
  plan = () => {
    var data = this.sns[this.state.sn];
    var plan = 'Contact Sales';
    if(
      typeof data === 'object' &&
      typeof data.plan !== 'undefined' && data.plan !== ''
    ) {
      if(data.plan === 'Upgrade')
        plan = 'Upgrade/Reconfigure';
      else if(data.plan === 'Subscription')
        plan = (data.current === 'true') ? 'Unsubscribe' : 'Subscribe';
      else
        plan = data.plan;
    }
    return plan;
  }
  checkoutbtn = () => {
    var plan = this.plan();
    if(plan === 'Contact Sales')
      return (
        <Typography>
          <a href="http://www.carlsonsw.com/where-to-purchase/dealers/" rel="noopener noreferrer" target="_blank">
            Please Contact Sales to Purchase
          </a>
        </Typography>
      );
    else
      return (
        <Button
          variant='raised'
          color='primary'
          disabled={this.subtotal() <= 0}
          onClick={() => this.setState({ step: 'checkout' })}
        >
          <Done style={{ transform: 'scale(.75)' }} /> {['Subscribe', 'Unsubscribe'].includes(plan) ? plan : 'Checkout'}
        </Button>
      );
  }
  handleCheck = (e) => {
    var parts = this.state.parts;
    var id = parseInt(e.target.value, 10);
    if(['a', 's'].includes(parts[id][2])) {
      parts[id][2] = (e.target.checked) ? 's' : 'a';
      this.setState({ parts: parts });
    }
  }
  content = () => {
    if(this.state.step === 'begin')
      return null;
    else if(this.state.step === 'invalid')
      return (
        <Typography variant='title'>
          Invalid Serial Number<br/>
          Please verify the Serial Number
        </Typography>
      );
    else if(this.state.step === 'loading')
      return <Loading />;
    else if(this.state.step === 'ineligible')
      return (
        <Typography variant='title'>
          Invalid Serial Number<br />
          or<br />
          Serial Number is not eligible to upgrade
        </Typography>
      );
    else if(this.state.step === 'found') {
      var data = this.sns[this.state.sn];
      var mods = '';
      Object.keys(data.modules).map((key) => (
        mods += ((mods === '') ? '' : ', ') + data.modules[key][0] +
          ((data.NETWORKLM === '1') ? (' x ' + data.modules[key][1]) : '')
      ));
      return (
        <div>
          <Typography variant='title'>{data.PRODUCTNAME}</Typography>
          <Typography variant='body1'>
            Network: {(data.NETWORKLM === '1') ? 'Yes' : 'No'}<br />
            Modules: {mods}
          </Typography>
          <Typography variant='caption'>
            Serial Number: {this.state.sn}
          </Typography>
          <p />
          <Grid container>
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8} className='ShoppingCart'>
              <div style={{ minHeight: '120px' }}>
                <table width='100%' className='ShoppingCartRow'>
                  <tbody>
                    {this.state.parts.map((part, id) => (
                      <tr key={id}>
                        <td style={{ paddingLeft: '20px' }}>
                          <Typography variant='subheading'>
                            {part[0]}
                          </Typography>
                          <Typography variant='caption'>
                            {['m', 'r', 'u'].includes(part[2]) ? 'Required Module' : (['e'].includes(part[2]) ? 'Existing Module' : 'Available Module')}
                          </Typography>
                        </td>
                        <td align="right" style={{ paddingRight: '20px' }}>
                          <Typography variant='subheading'>
                            {(['e'].includes(part[2]) ? 0 : part[1]).toLocaleString(
                              'en-US',
                              { style:'currency', currency:'USD', minimumFractionDigits: 2 }
                            )}
                          </Typography>
                        </td>
                        <td>
                          <Checkbox
                            color='primary'
                            value={'' + id}
                            checked={['a'].includes(part[2]) === false}
                            disabled={['a', 's'].includes(part[2]) === false}
                            onClick={this.handleCheck}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <Grid container justify='flex-start'>
                <Grid item size={6}>
                  <Button
                    color='secondary'
                    onClick={() => this.setState(
                      { step: 'begin', sn: '', parts: [] }
                    )}
                  >
                    <Clear />&nbsp; Clear
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <div className='ShoppingCartTotal'>
              <table width='100%' style={{ minHeight: '100px' }}>
                <tbody>
                  <tr>
                    <td align='left'>
                      <Typography variant='body1'>Subtotal</Typography>
                    </td>
                    <td align='right'>
                      <Typography>
                        {this.subtotal().toLocaleString(
                          'en-US', { style: 'currency', currency: 'USD' }
                        )}
                      </Typography>
                    </td>
                  </tr>
                  <tr><td colSpan='2'>&nbsp;</td></tr>
                  <tr>
                    <td colSpan='2' align='center'>{this.checkoutbtn()}</td>
                  </tr>
                </tbody>
              </table>
              <br />
              <Typography variant='caption'>
                <font size='1' style={{ fontStyle: 'italic' }}>
                  All pricing shown in United States Dollar (USD)
                </font>
              </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
      );
    }
    else if(this.state.step === 'checkout') {
      if(['Subscribe', 'Unsubscribe'].includes(this.plan()))
        return (
          <Subscription
            subscription={[{
              paln: this.plan(),
              serial: this.state.sn,
              name: this.sns[this.state.sn].PRODUCTNAME,
              description: 'Serial: ' + this.state.sn,
              quantity: 1,
              price: this.subtotal()
            }]}
            back={() => this.setState({ step: 'found', profile: null })}
          />
        );
      else if(
        this.state.profile === null || this.state.address === null || this.state.baddress === null
      )
        return(
          <ProfileAddress
            Back={() => this.setState({ step: 'found', profile: null })}
            Continue={(p, a, b) => this.setState({ profile: p, address: a, baddress: b })}
          />
        );
      else
        return (
          <Checkout
            checkout={[{
              paln: this.plan(),
              part: 'todo',
              serial: this.state.sn,
              name: this.sns[this.state.sn].PRODUCTNAME,
              description: 'Serial: ' + this.state.sn,
              quantity: 1,
              price: this.subtotal()
            }]}
            profile={this.state.profile}
            address={this.state.address}
            baddress={this.state.baddress}
            completed={() => this.setState(
              { step: 'begin', sn: '', parts: [] }
            )}
          />
        );
    }
    else
      return (
        <Typography variant='title'>
          Unknown error occurred<br />
          Please contact us using the email below
        </Typography>
      );
  }

  render() {
    return (
      <div>
        {['begin', 'invalid', 'ineligible'].includes(this.state.step) ?
          <ReconfigSearch
            sn={this.state.sn}
            handleChange={this.handleChange}
            handleSearch={this.handleSearch}
          /> : ''}
        <div style={{ minHeight: '105px', textAlign: 'center' }}>
          {this.content()}
        </div>
      </div>
    );
  }
}

export default Reconfig;



// WEBPACK FOOTER //
// ./src/components/home/Reconfig.js